import { create } from 'zustand'
import { persist } from 'zustand/middleware'
export type State = {
  lastVersion: string
  hasNewVersion: boolean
  showNeedUpdate: boolean
}

export type Action = {
  actions?: {
    setLastVersion: (version: string) => void
    setHasNewVersion: (hasNewVersion: boolean) => void
    setShowNeedUpdate: (showNeedUpdate: boolean) => void
  }
}

export const useVersionStore = create(
  persist<State & Action>(
    (set) => ({
      lastVersion: '',
      hasNewVersion: false,
      showNeedUpdate: false,
      actions: {
        setLastVersion: (lastVersion) => set({ lastVersion }),
        setHasNewVersion: (hasNewVersion) => set({ hasNewVersion }),
        setShowNeedUpdate: (showNeedUpdate) => set({ showNeedUpdate }),
      },
    }),
    {
      name: 'version-store',
      partialize: (state) => ({
        lastVersion: state.lastVersion,
        hasNewVersion: state.hasNewVersion,
        showNeedUpdate: state.showNeedUpdate,
      }),
    },
  ),
)
